import { CampaignDetailModelState } from '@urbanx/agx.campaigns.client'
import { BaseComplianceModalProps } from '../BaseComplianceModalProps'
import QldAgreementComplianceTypePage from './QldAgreementComplianceTypePage'
import NswAgreementComplianceTypePage from './NswAgreementComplianceTypePage'

const AgreementComplianceTypePage = (props: BaseComplianceModalProps) => {
  switch (props.campaign.state) {
    case CampaignDetailModelState.QLD:
      return <QldAgreementComplianceTypePage {...props} />
    case CampaignDetailModelState.NSW:
      return <NswAgreementComplianceTypePage {...props} />
    default:
      return null
  }
}

export default AgreementComplianceTypePage
